export type PokemonImageRequest = {
  image: string;
  gender: "M" | "F" | null;
};

export type PokemonMatch = {
  num: number;
  pokemon?: string | null;
  confidence: number;
  image?: string;
  gender?: "M" | "F" | null;
};

export type TeamSearchRequest = {
  regs: string[];
  pokemons: PokemonMatch[];
};

export type TeamSearchPokemon = {
  pokemon?: string | null;
  item?: string | null;
  tera_type?: string | null;
  ability?: string | null;
  nature?: string | null;
  evs?: number[] | null;
  evs2?: number[] | null;
  ivs?: number[] | null;
  moves?: string[] | null;
};

export type TeamSearchMatch = {
  id: string;
  author: string;
  xAccount: string | null;
  sharedDate: string | null;
  eventName: string | null;
  record: string | null;
  ranking: string | null;
  pokemons: TeamSearchPokemon[];
};

export type TeamSearchResponse = Record<string, unknown>;

export const MATCH_RESULT_GROUPS = [
  {
    key: "open_teams_pokemon_teamlist_1",
    title: "阵容一致公开队伍",
  },
  {
    key: "open_teams_pokemon_teamlist_2",
    title: "阵容类似公开队伍",
  },
  {
    key: "championship_pokemon_teamlist",
    title: "阵容类似大型赛事队伍",
  },
  {
    key: "limitless_pokemon_teamlist",
    title: "阵容类似 Limitless 比赛队伍",
  },
] as const;
